// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: content_rewards_app/content_rewards_app.proto

/* eslint-disable */
import type { FileAttachment } from "../common/attachment";
import type { Money } from "../common/money";
import type { User } from "../common/users";

export const ContentPlatform = {
  UNKNOWN_PLATFORM: "UNKNOWN_PLATFORM",
  INSTAGRAM: "INSTAGRAM",
  TIKTOK: "TIKTOK",
  X: "X",
  YOUTUBE: "YOUTUBE",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ContentPlatform = typeof ContentPlatform[keyof typeof ContentPlatform];

export namespace ContentPlatform {
  export type UNKNOWN_PLATFORM = typeof ContentPlatform.UNKNOWN_PLATFORM;
  export type INSTAGRAM = typeof ContentPlatform.INSTAGRAM;
  export type TIKTOK = typeof ContentPlatform.TIKTOK;
  export type X = typeof ContentPlatform.X;
  export type YOUTUBE = typeof ContentPlatform.YOUTUBE;
  export type UNRECOGNIZED = typeof ContentPlatform.UNRECOGNIZED;
}

export interface ContentRewardsCampaign {
  id: string;
  allowInstagram: boolean;
  allowTiktok: boolean;
  allowX: boolean;
  allowYoutube: boolean;
  totalBudget: Money | undefined;
  category: ContentRewardsCampaign_Category;
  contentType: ContentRewardsCampaign_ContentType;
  expiresAt?: string | undefined;
  pendingSubmissionsCount: number;
  requirements: string[];
  rewardRatePerThousandViews: Money | undefined;
  status: ContentRewardsCampaign_Status;
  submissionsCount: number;
  title: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  totalPaid: Money | undefined;
  fileUploadRequired: boolean;
  totalViewCount: number;
  autoApproveSubmissionsInHours?: number | undefined;
  requiredDescriptionText: string[];
  requiredCreatorBioLink?: string | undefined;
  requiredTiktokAudio?: string | undefined;
  requiredInstagramAudio?: string | undefined;
  fixedRewardPerSubmission?: Money | undefined;
  totalPendingPayouts: Money | undefined;
}

export const ContentRewardsCampaign_Status = {
  UNKNOWN: "UNKNOWN",
  ACTIVE: "ACTIVE",
  PENDING: "PENDING",
  EXPIRED: "EXPIRED",
  ARCHIVED: "ARCHIVED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ContentRewardsCampaign_Status =
  typeof ContentRewardsCampaign_Status[keyof typeof ContentRewardsCampaign_Status];

export namespace ContentRewardsCampaign_Status {
  export type UNKNOWN = typeof ContentRewardsCampaign_Status.UNKNOWN;
  export type ACTIVE = typeof ContentRewardsCampaign_Status.ACTIVE;
  export type PENDING = typeof ContentRewardsCampaign_Status.PENDING;
  export type EXPIRED = typeof ContentRewardsCampaign_Status.EXPIRED;
  export type ARCHIVED = typeof ContentRewardsCampaign_Status.ARCHIVED;
  export type UNRECOGNIZED = typeof ContentRewardsCampaign_Status.UNRECOGNIZED;
}

export const ContentRewardsCampaign_ContentType = {
  UNKNOWN_CONTENT_TYPE: "UNKNOWN_CONTENT_TYPE",
  UGC: "UGC",
  CLIPPING: "CLIPPING",
  /** @deprecated */
  FACELESS: "FACELESS",
  OTHER_CONTENT_TYPE: "OTHER_CONTENT_TYPE",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ContentRewardsCampaign_ContentType =
  typeof ContentRewardsCampaign_ContentType[keyof typeof ContentRewardsCampaign_ContentType];

export namespace ContentRewardsCampaign_ContentType {
  export type UNKNOWN_CONTENT_TYPE = typeof ContentRewardsCampaign_ContentType.UNKNOWN_CONTENT_TYPE;
  export type UGC = typeof ContentRewardsCampaign_ContentType.UGC;
  export type CLIPPING = typeof ContentRewardsCampaign_ContentType.CLIPPING;
  export type FACELESS = typeof ContentRewardsCampaign_ContentType.FACELESS;
  export type OTHER_CONTENT_TYPE = typeof ContentRewardsCampaign_ContentType.OTHER_CONTENT_TYPE;
  export type UNRECOGNIZED = typeof ContentRewardsCampaign_ContentType.UNRECOGNIZED;
}

export const ContentRewardsCampaign_Category = {
  UNKNOWN_CATEGORY: "UNKNOWN_CATEGORY",
  /** @deprecated */
  CREATOR: "CREATOR",
  /** @deprecated */
  BRAND: "BRAND",
  /** @deprecated */
  INFLUENCER: "INFLUENCER",
  /** @deprecated */
  STREAMER: "STREAMER",
  /** @deprecated */
  MUSICIAN: "MUSICIAN",
  OTHER: "OTHER",
  /** @deprecated */
  ECOMMERCE: "ECOMMERCE",
  LOGO: "LOGO",
  MUSIC: "MUSIC",
  /** @deprecated */
  PODCAST: "PODCAST",
  /** @deprecated */
  SOFTWARE: "SOFTWARE",
  /** @deprecated */
  STREAM: "STREAM",
  ENTERTAINMENT: "ENTERTAINMENT",
  PRODUCTS: "PRODUCTS",
  PERSONAL_BRAND: "PERSONAL_BRAND",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ContentRewardsCampaign_Category =
  typeof ContentRewardsCampaign_Category[keyof typeof ContentRewardsCampaign_Category];

export namespace ContentRewardsCampaign_Category {
  export type UNKNOWN_CATEGORY = typeof ContentRewardsCampaign_Category.UNKNOWN_CATEGORY;
  export type CREATOR = typeof ContentRewardsCampaign_Category.CREATOR;
  export type BRAND = typeof ContentRewardsCampaign_Category.BRAND;
  export type INFLUENCER = typeof ContentRewardsCampaign_Category.INFLUENCER;
  export type STREAMER = typeof ContentRewardsCampaign_Category.STREAMER;
  export type MUSICIAN = typeof ContentRewardsCampaign_Category.MUSICIAN;
  export type OTHER = typeof ContentRewardsCampaign_Category.OTHER;
  export type ECOMMERCE = typeof ContentRewardsCampaign_Category.ECOMMERCE;
  export type LOGO = typeof ContentRewardsCampaign_Category.LOGO;
  export type MUSIC = typeof ContentRewardsCampaign_Category.MUSIC;
  export type PODCAST = typeof ContentRewardsCampaign_Category.PODCAST;
  export type SOFTWARE = typeof ContentRewardsCampaign_Category.SOFTWARE;
  export type STREAM = typeof ContentRewardsCampaign_Category.STREAM;
  export type ENTERTAINMENT = typeof ContentRewardsCampaign_Category.ENTERTAINMENT;
  export type PRODUCTS = typeof ContentRewardsCampaign_Category.PRODUCTS;
  export type PERSONAL_BRAND = typeof ContentRewardsCampaign_Category.PERSONAL_BRAND;
  export type UNRECOGNIZED = typeof ContentRewardsCampaign_Category.UNRECOGNIZED;
}

export interface ContentRewardsSubmission {
  id: string;
  totalPaid: Money | undefined;
  totalViewCount: number;
  contentUrl: string;
  platform: ContentPlatform;
  status: ContentRewardsSubmission_Status;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  campaignId: string;
  platformPostId?: string | undefined;
  userId: string;
  user: User | undefined;
  attachments: FileAttachment[];
  totalLikeCount: number;
  totalCommentCount: number;
  totalSaveCount: number;
  totalShareCount: number;
  totalRepostCount: number;
}

export const ContentRewardsSubmission_Status = {
  UNKNOWN: "UNKNOWN",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  FLAGGED: "FLAGGED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ContentRewardsSubmission_Status =
  typeof ContentRewardsSubmission_Status[keyof typeof ContentRewardsSubmission_Status];

export namespace ContentRewardsSubmission_Status {
  export type UNKNOWN = typeof ContentRewardsSubmission_Status.UNKNOWN;
  export type PENDING = typeof ContentRewardsSubmission_Status.PENDING;
  export type APPROVED = typeof ContentRewardsSubmission_Status.APPROVED;
  export type REJECTED = typeof ContentRewardsSubmission_Status.REJECTED;
  export type FLAGGED = typeof ContentRewardsSubmission_Status.FLAGGED;
  export type UNRECOGNIZED = typeof ContentRewardsSubmission_Status.UNRECOGNIZED;
}

export interface ContentRewardsMessage {
  contentRewardsCampaign?: ContentRewardsCampaign | undefined;
  contentRewardsSubmission?: ContentRewardsSubmission | undefined;
}
